(function () {
  'use strict';

  var IP_API = 'https://webengagebackup.discoverpilgrim.com/polls/get_client_ip?format=json';
  var CITY_CACHE_KEY = 'pilgrim_uv_city_v1';
  var ELIGIBLE_CITY_MAP = {
    mumbai: true,
    pune: true,
    delhi: true,
    'new delhi': true
  };

  var CITY_DISPLAY_OVERRIDES = {
    'new delhi': 'Delhi'
  };
  var CITY_KEY_ALIASES = {
    'new delhi': 'delhi',
    delhi: 'new delhi'
  };

  // ₹495 in paise — qualifying threshold for BOGO item price check
  var BOGO_QUALIFY_PAISE = 49500;
  var SUNSCREEN_COLLECTION_HANDLES = ['sunscreen'];

  // ─── Styles (injected once) ──────────────────────────────────────────────────

  function injectStyles() {
    if (document.getElementById('uv-nudge-styles')) return;
    var s = document.createElement('style');
    s.id = 'uv-nudge-styles';
    s.textContent = '\
#cart-uv-nudge{\
  background:#ffffff;\
  margin-inline:-20px;\
  padding:0 20px 20px;\
}\
.uv-nudge{\
  display:flex;\
  flex-direction:column;\
  gap:12px;\
  padding-top:16px;\
}\
.uv-nudge__header{\
  display:flex;\
  align-items:center;\
  justify-content:space-between;\
}\
.uv-nudge__location-copy{\
  font-size:13px;\
  font-weight:400;\
  color:#1a1a1a;\
  letter-spacing:-0.028px;\
  margin:0;\
  line-height:1.2;\
}\
.uv-nudge__location-prefix{font-weight:400;}\
.uv-nudge__uv-summary{font-weight:600;}\
.uv-nudge__city-name{\
  font-weight:400;\
}\
.uv-nudge__today-status{\
  display:flex;\
  align-items:center;\
  gap:4px;\
}\
.uv-nudge__today-dot-wrap{\
  position:relative;\
  width:6px;\
  height:6px;\
  display:inline-flex;\
  align-items:center;\
  justify-content:center;\
}\
.uv-nudge__today-dot{\
  width:6px;\
  height:6px;\
  display:block;\
  position:relative;\
  z-index:2;\
}\
.uv-nudge__today-dot-glow{\
  position:absolute;\
  left:50%;\
  top:50%;\
  width:6px;\
  height:6px;\
  border-radius:50%;\
  transform:translate(-50%,-50%);\
  background:radial-gradient(circle,rgba(255,124,124,0.65) 0%,rgba(183,44,45,0.28) 44%,rgba(183,44,45,0) 68%);\
  animation:uvDotPulse 3.2s ease-out infinite;\
  z-index:1;\
  pointer-events:none;\
}\
.uv-nudge__today-dot-glow--alt{\
  animation-delay:1.6s;\
}\
.uv-nudge__today-text{\
  font-size:13px;\
  font-weight:500;\
  color:#b72c2d;\
  letter-spacing:-0.36px;\
}\
@keyframes uvDotPulse{\
  0%{\
    transform:translate(-50%,-50%) scale(1);\
    opacity:0.95;\
  }\
  70%{\
    transform:translate(-50%,-50%) scale(3.2);\
    opacity:0;\
  }\
  100%{\
    transform:translate(-50%,-50%) scale(3.2);\
    opacity:0;\
  }\
}\
.uv-nudge__scale-wrap{\
  display:flex;\
  flex-direction:column;\
  gap:6px;\
  width:100%;\
}\
.uv-nudge__scale-bar{\
  height:8px;\
  border-radius:999px;\
  position:relative;\
  background:linear-gradient(90deg,#2fb262 0%,#d09f3e 49%,#ea6f46 70%,#ef5160 100%);\
  width:100%;\
}\
.uv-nudge__scale-pointer{\
  position:absolute;\
  top:50%;\
  width:14px;\
  height:14px;\
  border-radius:50%;\
  background:#ffffff;\
  border:2px solid #333333;\
  box-shadow:0 1px 3px rgba(0,0,0,0.25);\
  transform:translate(-50%,-50%);\
  transition:left 0.4s ease;\
  pointer-events:none;\
  z-index:2;\
}\
.uv-nudge__scale-labels{\
  display:flex;\
  align-items:center;\
  justify-content:space-between;\
  font-size:11px;\
  color:#6e6b6b;\
  letter-spacing:-0.022px;\
  text-transform:uppercase;\
  line-height:1;\
}\
.uv-nudge__scale-labels span{\
  white-space:nowrap;\
}\
.uv-nudge__scale-labels span:last-child{\
  text-align:right;\
  white-space:nowrap;\
}\
.uv-nudge__card-wrap{\
  display:flex;\
  flex-direction:column;\
  gap:6px;\
  width:100%;\
  margin-top:12px;\
}\
.uv-nudge__product-card{\
  border:1px solid #e1e1e1;\
  border-radius:12px;\
  overflow:hidden;\
  background:#fff;\
}\
.uv-nudge__product-top{\
  display:flex;\
  align-items:flex-start;\
  width:100%;\
}\
.uv-nudge__image-wrap{\
  position:relative;\
  width:94px;\
  height:94px;\
  flex-shrink:0;\
  border-radius:8px;\
  overflow:hidden;\
}\
.uv-nudge__product-img{\
  width:100%;\
  height:100%;\
  object-fit:cover;\
  display:block;\
  border-radius:8px;\
}\
.uv-nudge__rating-badge{\
  position:absolute;\
  bottom:3.2px;\
  left:47px;\
  display:flex;\
  align-items:center;\
  gap:3px;\
  background:rgba(255,255,255,0.82);\
  border:0.64px solid #f3f3f3;\
  border-radius:24px;\
  padding:1px 4px;\
  backdrop-filter:blur(2.4px);\
  -webkit-backdrop-filter:blur(2.4px);\
  white-space:nowrap;\
}\
.uv-nudge__rating-val{\
  font-size:11px;\
  color:#1a1a1a;\
  font-weight:500;\
  letter-spacing:-0.02px;\
}\
.uv-nudge__product-info{\
  flex:1;\
  padding:6px 4px;\
  display:flex;\
  flex-direction:column;\
  gap:4px;\
  min-width:0;\
}\
.uv-nudge__bestseller-tag{\
  display:inline-flex;\
  align-items:center;\
  gap:4px;\
  font-size:12px;\
  font-weight:600;\
  color:#018901;\
  letter-spacing:-0.024px;\
}\
.uv-nudge__bestseller-icon{\
  flex-shrink:0;\
  display:block;\
}\
.uv-nudge__product-desc{\
  display:flex;\
  flex-direction:column;\
  gap:3px;\
  width:100%;\
}\
.uv-nudge__product-name{\
  font-size:14px;\
  font-weight:510;\
  color:#262b3e;\
  letter-spacing:-0.14px;\
  line-height:1.2;\
  margin:0;\
  display:-webkit-box;\
  -webkit-line-clamp:2;\
  -webkit-box-orient:vertical;\
  overflow:hidden;\
}\
.uv-nudge__product-type-tag{\
  display:block;\
  color:#6b6b6b;\
  font-size:12px;\
  font-weight:400;\
  letter-spacing:-0.026px;\
  line-height:1.2;\
  width:100%;\
  white-space:nowrap;\
  overflow:hidden;\
  text-overflow:ellipsis;\
}\
.uv-nudge__divider{\
  height:1px;\
  background:#f3f3f3;\
  border:none;\
  margin:0;\
}\
.uv-nudge__price-row{\
  display:flex;\
  align-items:center;\
  justify-content:space-between;\
  padding:6px 8px 8px;\
  gap:8px;\
}\
.uv-nudge__pricing{\
  display:flex;\
  align-items:center;\
  gap:4px;\
  overflow:hidden;\
  white-space:nowrap;\
}\
.uv-nudge__pricing--bogo-free .uv-nudge__effective-price{order:1;}\
.uv-nudge__pricing--bogo-free .uv-nudge__mrp{order:2;}\
.uv-nudge__pricing--bogo-free .uv-nudge__free-label{order:3;}\
.uv-nudge__effective-price{\
  font-size:16px;\
  font-weight:500;\
  color:#414449;\
  letter-spacing:0;\
  line-height:1;\
  white-space:nowrap;\
}\
.uv-nudge__free-label{\
  font-size:15px;\
  font-weight:600;\
  color:#069e6d;\
  letter-spacing:0;\
  line-height:1;\
  white-space:nowrap;\
}\
.uv-nudge__mrp{\
  font-size:15px;\
  font-weight:500;\
  color:#b3b4b6;\
  letter-spacing:0;\
  line-height:1;\
  white-space:nowrap;\
}\
.uv-nudge__mrp.is-strikethrough{text-decoration:line-through;}\
.uv-nudge__discount-pct{\
  font-size:15px;\
  font-weight:600;\
  color:#069e6d;\
  letter-spacing:0;\
  line-height:1;\
  white-space:nowrap;\
}\
.uv-nudge__add-btn{\
  background:linear-gradient(158.19deg,#FACA0C 10.13%,#FAB30C 93.74%);\
  color:#1a1a1a;\
  font-size:14px;\
  font-weight:600;\
  padding:8px 32px;\
  border:none;\
  border-radius:8px;\
  cursor:pointer;\
  white-space:nowrap;\
  flex-shrink:0;\
  letter-spacing:-0.028px;\
  font-family:inherit;\
  line-height:1;\
  position:relative;\
  overflow:hidden;\
}\
.uv-nudge__add-btn:disabled{opacity:0.6;cursor:not-allowed;}\
.uv-nudge__promo-text{\
  font-size:11px;\
  color:#414449;\
  margin:0;\
  line-height:1.4;\
  text-align:left;\
  width:100%;\
}\
.uv-nudge__promo-text-strong{\
  font-weight:600;\
  color:#414449;\
}\
}';
    document.head.appendChild(s);
  }

  // ─── City detection (cached per session) ────────────────────────────────────

  function normalizeCityKey(city) {
    return String(city || '').trim().toLowerCase();
  }

  function isEligibleCity(city) {
    return !!ELIGIBLE_CITY_MAP[normalizeCityKey(city)];
  }

  function getUvIndexForCity(uvDataByCity, city) {
    var normalizedCity = normalizeCityKey(city);
    var uvValue = Number(uvDataByCity[normalizedCity]);
    if (!Number.isNaN(uvValue) && uvValue > 0) return uvValue;

    var aliasCity = CITY_KEY_ALIASES[normalizedCity];
    if (!aliasCity) return Number.NaN;
    return Number(uvDataByCity[aliasCity]);
  }

  function toTitleCase(value) {
    return String(value || '')
      .split(/\s+/)
      .filter(Boolean)
      .map(function (word) {
        return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
      })
      .join(' ');
  }

  function getCityDisplayName(cityKey) {
    var normalized = normalizeCityKey(cityKey);
    if (!normalized) return 'Mumbai';
    return CITY_DISPLAY_OVERRIDES[normalized] || toTitleCase(normalized);
  }

  function normalizeUvData(rawData) {
    if (!rawData || typeof rawData !== 'object') return {};
    var normalized = {};

    function assignValue(cityKey, value) {
      var key = normalizeCityKey(cityKey);
      var numericValue = Number(value);
      if (!key || Number.isNaN(numericValue)) return;
      normalized[key] = numericValue;
    }

    var properties = rawData.properties;
    if (properties && typeof properties === 'object' && !Array.isArray(properties)) {
      Object.keys(properties).forEach(function (cityName) {
        var cityData = properties[cityName];
        if (cityData && typeof cityData === 'object' && !Array.isArray(cityData) && cityData.temp !== undefined) {
          assignValue(cityName, cityData.temp);
        }
      });
      return normalized;
    }

    // Backward compatibility with legacy flat map: { "mumbai": 8 }
    Object.keys(rawData).forEach(function (cityName) {
      assignValue(cityName, rawData[cityName]);
    });
    return normalized;
  }

  async function getCity() {
    var cached = sessionStorage.getItem(CITY_CACHE_KEY);
    if (cached !== null) return cached; // empty string = unsupported city

    try {
      var res = await fetch(IP_API, { credentials: 'omit' });
      var data = await res.json();
      var city = normalizeCityKey(data.city);
      sessionStorage.setItem(CITY_CACHE_KEY, city);
      return city;
    } catch (e) {
      sessionStorage.setItem(CITY_CACHE_KEY, '');
      return '';
    }
  }

  // ─── UV label helper ─────────────────────────────────────────────────────────

  function getUVLabel(uv) {
    if (uv >= 11) return { text: 'Extreme',   level: 'extreme' };
    if (uv >= 8)  return { text: 'Very High', level: 'very-high' };
    if (uv >= 6)  return { text: 'High',      level: 'high' };
    if (uv >= 4)  return { text: 'Moderate',  level: 'moderate' };
    return            { text: 'Low',       level: 'low' };
  }

  function getUVPointerPercent(uv) {
    if (!uv || uv < 0) return 0;
    if (uv > 12) return 100;
    return Math.round((uv / 12) * 100);
  }

  function getUVAdvisoryCopy(uvInfo) {
    if (!uvInfo) return 'Protect your skin with Broad-spectrum SPF 50+ before stepping out.';
    if (uvInfo.level === 'extreme') {
      return 'Extreme UV today — reapply Broad-spectrum SPF 50+ frequently and avoid direct noon sun.';
    }
    if (uvInfo.level === 'very-high') {
      return 'Very high UV today — protect your skin with Broad-spectrum SPF 50+ for intense sun exposure.';
    }
    if (uvInfo.level === 'high') {
      return 'High UV today — use Broad-spectrum SPF 50+ and reapply every few hours outdoors.';
    }
    if (uvInfo.level === 'moderate') {
      return 'Moderate UV today — daily Broad-spectrum SPF 50+ helps prevent sun damage.';
    }
    return 'Low UV today — keep your daily sunscreen habit for complete skin protection.';
  }

  function safeParseJson(value, fallback) {
    if (typeof value !== 'string' || !value) return fallback;
    try {
      return JSON.parse(value);
    } catch (error) {
      return fallback;
    }
  }

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function toBoolean(value) {
    return value === true || value === 'true';
  }

  function setElementHidden(element, shouldHide) {
    if (!element) return;
    if (shouldHide) {
      element.setAttribute('hidden', '');
    } else {
      element.removeAttribute('hidden');
    }
  }

  function getConfigFromElement(element) {
    if (!element) return null;

    var enabled = toBoolean(element.getAttribute('data-enabled'));
    if (!enabled) return null;

    var productHandle = element.getAttribute('data-product-handle') || '';
    var variantId = Number(element.getAttribute('data-variant-id'));
    var mrp = Number(element.getAttribute('data-mrp'));
    var uvData = safeParseJson(element.getAttribute('data-uv-data'), {});
    var activeOffers = safeParseJson(element.getAttribute('data-active-offers'), []);

    if (!productHandle || Number.isNaN(variantId) || Number.isNaN(mrp)) return null;

    return {
      enabled: true,
      productHandle: productHandle,
      variantId: variantId,
      mrp: mrp,
      autoApply: toBoolean(element.getAttribute('data-auto-apply')),
      uvData: uvData,
      activeOffers: Array.isArray(activeOffers) ? activeOffers : []
    };
  }

  // ─── Offer type detection ────────────────────────────────────────────────────

  function detectOfferCategory(title) {
    var t = (title || '').toLowerCase();
    if (/b1g1|buy[\s-]*1[\s-]*get[\s-]*1/.test(t)) return 'bogo_b1g1';
    if (/b2g2|buy[\s-]*2[\s-]*get[\s-]*2/.test(t)) return 'bogo_b2g2';
    if (/b3g3|buy[\s-]*3[\s-]*get[\s-]*3/.test(t)) return 'bogo_b3g3';
    // "Buy 2 Get 1 Free" — sunscreen is the free item
    if (/buy[\s-]*2[\s-]*get[\s-]*1/.test(t)) return 'bogo_b1g1';
    var pct = parsePct(title);
    if (pct > 0) return 'flat_percent';
    return null;
  }

  function parsePct(title) {
    var m = (title || '').match(/(\d+)\s*%/);
    return m ? parseInt(m[1], 10) : 0;
  }

  function getBogoTierRank(bogoType) {
    if (bogoType === 'bogo_b3g3') return 3;
    if (bogoType === 'bogo_b2g2') return 2;
    return 1; // bogo_b1g1
  }

  function getBogoPromoLabel(bogoType) {
    if (bogoType === 'bogo_b3g3') return 'Buy 3 Get 3 Free';
    if (bogoType === 'bogo_b2g2') return 'Buy 2 Get 2 Free';
    return 'Buy 1 Get 1 Free';
  }

  function getBogoDeltaOffer(mrpRs, comparableItemPaise, promoLabel) {
    var comparableRs = Math.round(Number(comparableItemPaise || 0) / 100);
    var effectivePrice = Math.max(mrpRs - comparableRs, 0);
    var discountPct = mrpRs > 0
      ? Math.round(((mrpRs - effectivePrice) / mrpRs) * 100)
      : 0;
    return {
      type: 'bogo_mrp',
      mrp: mrpRs,
      promoLabel: promoLabel,
      effectivePrice: effectivePrice,
      discountLabel: discountPct + '% Off'
    };
  }

  // ─── Offer computation ───────────────────────────────────────────────────────

  // Build a map of product handle → [collection handles] from DOM line-item attributes.
  // The cart drawer renders each line-item with data-product-colletion (comma-separated).
  function _buildProductCollectionMap() {
    var map = {};
    var nodes = document.querySelectorAll('.line-item[data-product-handle]');
    for (var i = 0; i < nodes.length; i++) {
      var handle  = nodes[i].getAttribute('data-product-handle');
      var collStr = nodes[i].getAttribute('data-product-colletion') || '';
      if (handle) {
        map[handle] = collStr.split(',').map(function (s) { return s.trim(); }).filter(Boolean);
      }
    }
    return map;
  }

  // Returns true if the cart item is in at least one of the offer's applicable collections.
  // If applicableCollections is empty/missing the offer applies to everything.
  function _isItemEligible(item, applicableCollections, productCollMap) {
    if (!applicableCollections || applicableCollections.length === 0) return true;
    var itemColls = productCollMap[item.handle] || [];
    for (var i = 0; i < applicableCollections.length; i++) {
      if (itemColls.indexOf(applicableCollections[i]) !== -1) return true;
    }
    return false;
  }

  function computeOffer(activeOffers, cartTotalPaise, cartLineItems, mrpPaise) {
    if (!activeOffers || activeOffers.length === 0) return null;

    var mrpRs = Math.round(mrpPaise / 100);
    var productCollMap = _buildProductCollectionMap();

    var flatTiers = [];
    var bogoOffers = [];

    for (var i = 0; i < activeOffers.length; i++) {
      var offer    = activeOffers[i];
      var category = detectOfferCategory(offer.title);
      if (!category) continue;

      if (category !== 'flat_percent') {
        bogoOffers.push({
          bogoType: category,
          applicableCollections: offer.applicableCollections || []
        });
      } else {
        var pct = parsePct(offer.title);
        flatTiers.push({
          pct: pct,
          applicableCollections: offer.applicableCollections || []
        });
      }
    }

    // BOGO takes priority over flat
    if (bogoOffers.length > 0) {
      var bestBogo = _computeBestBogo(bogoOffers, cartLineItems, mrpRs, productCollMap);
      if (bestBogo) return bestBogo;
    }

    if (flatTiers.length > 0) {
      return _computeFlat(flatTiers, cartLineItems, mrpRs, productCollMap);
    }

    return null;
  }

  function _computeFlat(tiers, cartLineItems, mrpRs, productCollMap) {
    // Use the applicable collections from the first tier (all tiers share the same restriction)
    var applicableCollections = tiers[0].applicableCollections || [];

    // Sum only eligible items' line prices
    var eligibleValueRs = 0;
    for (var i = 0; i < cartLineItems.length; i++) {
      if (_isItemEligible(cartLineItems[i], applicableCollections, productCollMap)) {
        eligibleValueRs += cartLineItems[i].line_price / 100;
      }
    }

    if (eligibleValueRs < 204) return null;

    // Sort by pct ascending so tiers[0] = lowest discount, tiers[last] = highest
    tiers.sort(function (a, b) { return a.pct - b.pct; });

    // Below ₹704 eligible value → lowest tier; ₹704+ → highest tier
    var tier = (tiers.length > 1 && eligibleValueRs >= 704) ? tiers[tiers.length - 1] : tiers[0];

    var effectivePrice = Math.round(mrpRs * (1 - tier.pct / 100));
    return { type: 'flat', effectivePrice: effectivePrice, mrp: mrpRs, discountLabel: tier.pct + '% Off' };
  }

  function _computeBestBogo(bogoOffers, cartLineItems, mrpRs, productCollMap) {
    var bestOffer = null;
    var bestRank = -1;

    for (var i = 0; i < bogoOffers.length; i++) {
      var current = bogoOffers[i];
      var resolved = _computeBogo(current.bogoType, cartLineItems, mrpRs, current.applicableCollections, productCollMap);
      if (!resolved) continue;

      var currentRank = getBogoTierRank(current.bogoType);
      if (currentRank > bestRank) {
        bestOffer = resolved;
        bestRank = currentRank;
      }
    }

    return bestOffer;
  }

  function _computeBogo(bogoType, cartLineItems, mrpRs, applicableCollections, productCollMap) {
    // Build eligible unit prices (uses quantity, not just line count)
    var eligibleItems = cartLineItems.filter(function (item) {
      return _isItemEligible(item, applicableCollections, productCollMap);
    });
    var eligibleUnitPrices = [];
    for (var i = 0; i < eligibleItems.length; i++) {
      var unitPrice = Number(eligibleItems[i].original_price) || 0;
      var qty = Number(eligibleItems[i].quantity) || 1;
      for (var q = 0; q < qty; q++) {
        eligibleUnitPrices.push(unitPrice);
      }
    }
    var itemCount = eligibleUnitPrices.length;
    var promoLabel = getBogoPromoLabel(bogoType);
    var sunscreenPricePaise = Math.round(mrpRs * 100);

    if (bogoType === 'bogo_b1g1') {
      // Start with B1G1 only at exactly one eligible item.
      if (itemCount !== 1) return null;

      var b1g1SortedPrices = eligibleUnitPrices.slice().sort(function (a, b) {
        return a - b;
      });
      var b1g1ReferencePrice = Number(b1g1SortedPrices[0] || 0);

      if (sunscreenPricePaise <= b1g1ReferencePrice) {
        return { type: 'bogo_free', mrp: mrpRs, promoLabel: promoLabel };
      }
      return getBogoDeltaOffer(mrpRs, b1g1ReferencePrice, promoLabel);
    }

    if (bogoType === 'bogo_b2g2') {
      // Next nudge stage: B2G2 at exactly 2 or 3 eligible items.
      if (itemCount < 2 || itemCount > 3) return null;
      if (itemCount === 2) return { type: 'bogo_mrp', mrp: mrpRs, promoLabel: promoLabel };

      var b2g2SortedPrices = eligibleUnitPrices.slice().sort(function (a, b) {
        return a - b;
      });
      // For 3 items: item1 free, paid items are item2/item3 -> compare with item2.
      var b2g2CheapestPaid = Number(b2g2SortedPrices[1] || 0);

      if (sunscreenPricePaise <= b2g2CheapestPaid) {
        return { type: 'bogo_free', mrp: mrpRs, promoLabel: promoLabel };
      }
      return getBogoDeltaOffer(mrpRs, b2g2CheapestPaid, promoLabel);
    }

    if (bogoType === 'bogo_b3g3') {
      // Final nudge stage: B3G3 at 4/5/6+ eligible items.
      if (itemCount < 4) return null;
      if (itemCount === 4 || itemCount >= 6) {
        return { type: 'bogo_mrp', mrp: mrpRs, promoLabel: promoLabel };
      }

      var b3g3SortedPrices = eligibleUnitPrices.slice().sort(function (a, b) {
        return a - b;
      });
      // For 5 items: item1/item2 free, paid items are item3/item4/item5 -> compare with item3.
      var b3g3CheapestPaid = Number(b3g3SortedPrices[2] || 0);

      if (sunscreenPricePaise <= b3g3CheapestPaid) {
        return { type: 'bogo_free', mrp: mrpRs, promoLabel: promoLabel };
      }
      return getBogoDeltaOffer(mrpRs, b3g3CheapestPaid, promoLabel);
    }

    return null;
  }

  // ─── UI update ───────────────────────────────────────────────────────────────

  function updateUI(city, uvIndex, offer, config) {
    var el = document.getElementById('cart-uv-nudge');
    if (!el) return;

    // City + UV header
    var headerEl = el.querySelector('.uv-nudge__header');
    if (city && uvIndex) {
      el.querySelector('.uv-nudge__city-name').textContent = getCityDisplayName(city);
      var uvInfo = getUVLabel(uvIndex);
      var uvSummaryEl = el.querySelector('.uv-nudge__uv-summary');
      var scalePointer = el.querySelector('.uv-nudge__scale-pointer');
      var advisoryTextEl = el.querySelector('.uv-nudge__advisory-text');

      if (uvSummaryEl) {
        uvSummaryEl.textContent = 'UV ' + uvIndex + ' (' + uvInfo.text + ')';
      }
      if (scalePointer) {
        scalePointer.style.left = getUVPointerPercent(uvIndex) + '%';
      }
      if (advisoryTextEl) {
        advisoryTextEl.textContent = getUVAdvisoryCopy(uvInfo);
      }
      setElementHidden(headerEl, false);
    } else {
      setElementHidden(headerEl, true);
    }

    // Pricing elements
    var effectiveEl = el.querySelector('.uv-nudge__effective-price');
    var freeEl      = el.querySelector('.uv-nudge__free-label');
    var mrpEl       = el.querySelector('.uv-nudge__mrp');
    var pctEl       = el.querySelector('.uv-nudge__discount-pct');
    var pricingEl   = el.querySelector('.uv-nudge__pricing');

    // Reset state
    setElementHidden(effectiveEl, false);
    setElementHidden(freeEl, true);
    setElementHidden(mrpEl, false);
    mrpEl.classList.remove('is-strikethrough');
    setElementHidden(pctEl, true);
    if (pricingEl) pricingEl.classList.remove('uv-nudge__pricing--bogo-free');

    if (offer.type === 'flat') {
      effectiveEl.textContent = '₹' + offer.effectivePrice;
      mrpEl.textContent       = '₹' + offer.mrp;
      mrpEl.classList.add('is-strikethrough');
      pctEl.textContent  = offer.discountLabel;
      setElementHidden(pctEl, false);
    } else if (offer.type === 'bogo_free') {
      setElementHidden(effectiveEl, false);
      effectiveEl.textContent   = '₹0';
      setElementHidden(freeEl, false);
      mrpEl.textContent         = '₹' + offer.mrp;
      mrpEl.classList.add('is-strikethrough');
      if (pricingEl) pricingEl.classList.add('uv-nudge__pricing--bogo-free');
    } else if (offer.type === 'mrp_only') {
      // Not eligible for any offer — show at full MRP, no strikethrough, no badge
      effectiveEl.textContent = '₹' + offer.mrp;
      setElementHidden(mrpEl, true);
      setElementHidden(pctEl, true);
    } else {
      // bogo_mrp — default full MRP, or computed effective price when applicable
      if (typeof offer.effectivePrice === 'number' && offer.effectivePrice < offer.mrp) {
        effectiveEl.textContent = '₹' + offer.effectivePrice;
        mrpEl.textContent = '₹' + offer.mrp;
        mrpEl.classList.add('is-strikethrough');
        pctEl.textContent = offer.discountLabel || '';
        setElementHidden(mrpEl, false);
        setElementHidden(pctEl, false);
      } else {
        effectiveEl.textContent = '₹' + offer.mrp;
        setElementHidden(mrpEl, true);
      }
    }

    // Promo text:
    // - Flat offers: show only when discount is not auto-applied.
    // - BOGO offers: hidden (auto-applied).
    var promoEl = el.querySelector('.uv-nudge__promo-text');
    if (promoEl) {
      var showPromo = offer.type === 'flat' && !config.autoApply;
      setElementHidden(promoEl, !showPromo);
      if (showPromo) {
        if (offer.type === 'flat') {
          var discountLabel = escapeHtml(offer.discountLabel || '');
          promoEl.innerHTML = '*Add this product and apply <span class="uv-nudge__promo-text-strong">Flat ' + discountLabel + '</span> offer to unlock ' + discountLabel.toLowerCase() + '.';
        }
      }
    }

    setElementHidden(el, false);
    el.removeAttribute('aria-hidden');
  }

  function hideNudgeElement(element) {
    if (!element) return;
    setElementHidden(element, true);
    element.setAttribute('aria-hidden', 'true');
  }

  // ─── Add to cart ─────────────────────────────────────────────────────────────

  // ─── Main init ───────────────────────────────────────────────────────────────

  // cartData is optionally passed from the cart:refresh event detail to skip
  // the redundant /cart.js fetch and show the nudge immediately.
  async function init(cartData) {
    var el = document.getElementById('cart-uv-nudge');
    if (!el) return;

    var config = window.uvNudgeConfig || getConfigFromElement(el);
    if (!config || !config.enabled) return;

    // Keep global config hydrated for refresh cycles and late inits.
    window.uvNudgeConfig = config;

    var cart = cartData || null;
    if (!cart) {
      try {
        cart = await fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) {
          return r.json();
        });
      } catch (e) {
        return;
      }
    }

    // Don't show UV widget on empty cart.
    if (!cart.items || cart.items.length === 0) {
      hideNudgeElement(el);
      return;
    }

    var inCart = cart.items.some(function (item) {
      return item.handle === config.productHandle;
    });
    if (inCart) { hideNudgeElement(el); return; }

    // Hide UV nudge if any sunscreen product is already present in cart.
    var productCollMap = _buildProductCollectionMap();
    var hasSunscreenInCart = cart.items.some(function (item) {
      var itemCollections = (productCollMap[item.handle] || []).map(function (h) {
        return String(h || '').toLowerCase();
      });
      return itemCollections.some(function (handle) {
        return SUNSCREEN_COLLECTION_HANDLES.indexOf(handle) !== -1;
      });
    });
    if (hasSunscreenInCart) { hideNudgeElement(el); return; }

    var city = await getCity();
    if (!isEligibleCity(city)) {
      hideNudgeElement(el);
      return;
    }

    var normalizedUvData = normalizeUvData(config.uvData || {});
    var uvIndex = getUvIndexForCity(normalizedUvData, city);
    if (!city || Number.isNaN(uvIndex) || uvIndex <= 0) {
      hideNudgeElement(el);
      return;
    }

    var offer = computeOffer(config.activeOffers, cart.total_price, cart.items, config.mrp);
    // Not eligible for any offer — show at full MRP (no discount, no promo text)
    if (!offer) {
      offer = { type: 'mrp_only', mrp: Math.round(config.mrp / 100) };
    }

    updateUI(city, uvIndex, offer, config);
  }

  // ─── Bootstrap ───────────────────────────────────────────────────────────────

  injectStyles();

  window.initUVNudge = init;

  var _debounceTimer;
  var _lastCart = null; // cache — lets MutationObserver re-init without a fetch

  function scheduleInit(delayMs, cartData) {
    if (cartData) _lastCart = cartData; // keep cache fresh
    clearTimeout(_debounceTimer);
    _debounceTimer = setTimeout(function () {
      // Use cached cart data when available — avoids a network round-trip and
      // makes the nudge appear almost instantly after any section re-render.
      init(_lastCart);
    }, delayMs);
  }

  // First page load — cache is empty, init falls back to /cart.js fetch
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { scheduleInit(0); });
  } else {
    scheduleInit(0);
  }

  // cart:refresh carries fresh cart data in event.detail.cart — update the
  // cache and re-init after a short settle so the mini-cart HTML has landed.
  document.documentElement.addEventListener('cart:refresh', function (e) {
    var cartData = e && e.detail && e.detail.cart;
    scheduleInit(50, cartData || null);
  });

  // MutationObserver — if the mini-cart section re-renders for any reason
  // (second cart:refresh, drawer open, etc.) it resets #cart-uv-nudge to
  // display:none. Detect the re-insertion and immediately re-init from cache
  // so the nudge never stays hidden after a section refresh.
  var _nudgeObserver = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var added = mutations[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var node = added[j];
        if (node.nodeType !== 1) continue;
        var found = node.id === 'cart-uv-nudge' ||
                    (node.querySelector && node.querySelector('#cart-uv-nudge'));
        if (found) {
          scheduleInit(20); // _lastCart used — no fetch needed
          return;
        }
      }
    }
  });

  function attachObserver() {
    var root = document.getElementById('mini-cart') || document.body;
    _nudgeObserver.observe(root, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', attachObserver);
  } else {
    attachObserver();
  }

  // When the cart drawer opens (open attribute set on cart-drawer), re-run init.
  // This covers the 600ms delayed re-render path: the CartDrawer injects new HTML
  // AND opens the drawer in the same setTimeout — our MutationObserver fires but a
  // subsequent cart:refresh (from freebie/milestone processing) can replace the
  // innerHTML again before we finish showing the nudge. Watching the drawer open
  // event gives us a reliable "drawer is now visible and settled" signal.
  var _drawerAttrObserver = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var m = mutations[i];
      if (m.type === 'attributes' && m.attributeName === 'open' &&
          m.target.hasAttribute('open')) {
        scheduleInit(80); // short settle — uses _lastCart, no fetch
        return;
      }
    }
  });

  function attachDrawerObserver() {
    var drawer = document.querySelector('cart-drawer');
    if (drawer) {
      _drawerAttrObserver.observe(drawer, { attributes: true, attributeFilter: ['open'] });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', attachDrawerObserver);
  } else {
    attachDrawerObserver();
  }

})();
